import { createContext } from 'react';

export const APP_DEFAULT_VALUE = {
    navHeight: 42
}

export const AppContext = createContext(APP_DEFAULT_VALUE);
export const AppProvider = AppContext.Provider;